/**
 * Banners de créditos del Home ocultados con su X (FINA-3378): duran la sesión. Viven en
 * `sessionStorage` (se borra al cerrar la pestaña) y `AuthService.logout` los limpia con
 * `clearBannerHides()`. Un `Set` en memoria cubre el storage bloqueado: ahí el banner sigue oculto
 * hasta recargar. Claves sin PII: `cr_banner_hidden_<banner>_<estado o id>`, para que un estado
 * nuevo (otra variante, otra oferta) vuelva a mostrarse.
 */
export const CR_BANNER_HIDDEN_PREFIX = 'cr_banner_hidden_';

export const crBannerHiddenKey = (...parts: (string | number)[]): string => `${CR_BANNER_HIDDEN_PREFIX}${parts.join('_')}`;

const hiddenInMemory = new Set<string>();

export function isBannerHidden(key: string): boolean {
    if (hiddenInMemory.has(key)) return true;
    try {
        return window.sessionStorage.getItem(key) === '1';
    } catch {
        return false;
    }
}

export function hideBanner(key: string): void {
    hiddenInMemory.add(key);
    try {
        window.sessionStorage.setItem(key, '1');
    } catch {
        // Sin storage queda solo en memoria (hasta recargar).
    }
}

/** Vuelve a mostrar todos los banners ocultos (al cerrar sesión). */
export function clearBannerHides(): void {
    hiddenInMemory.clear();
    try {
        const storage = window.sessionStorage;
        const keys: string[] = [];
        for (let i = 0; i < storage.length; i++) {
            const key = storage.key(i);
            if (key?.startsWith(CR_BANNER_HIDDEN_PREFIX)) keys.push(key);
        }
        keys.forEach(key => storage.removeItem(key));
    } catch {
        // Sin storage no hay nada que limpiar.
    }
}
